module.exports = __webpack_public_path__ + "36d2ed60188f7160a68f66d3c7ef5944.MP3";